import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import styles from './Administrators.module.less';

const Administrators = (props) => {
  return (
    <div>
      <div className={styles.header}>{gettext('Administrators')}</div>
      {props.isLoading && (
        <div className={styles.fields}>
          <div style={{ fontSize: 20, lineHeight: 1.8, width: 400 }}>
            <Skeleton count={4} />
          </div>
        </div>
      )}
      {!props.isLoading &&
        props.administrators.map((admin) => (
          <div className={styles.container} key={admin.email}>
            <strong className={styles.administratorName}>
              {admin.first_name} {admin.last_name}:
            </strong>
            <div className={styles.administratorEmail}>{admin.email}</div>
          </div>
        ))}

      <div className={styles.sectionSeparator} />
    </div>
  );
};

Administrators.propTypes = {
  isLoading: PropTypes.bool,
  administrators: PropTypes.array,
};

export default Administrators;
